import { LoginForm } from 'components/core-v2/organisms/forms'

import { COPY } from '../constants'
import { TwoColumnWithImage } from '../templates/TwoColumnWithImage'

export const Login = () => (
  <TwoColumnWithImage mainElement={<LoginForm />} title={COPY.login.title} />
)
